<label> {{ 'passwd.require' | loc }}: </label>
<div class="checks-{{ columns }}">
  <app-form-requirement labelKey="passwd.small" key="noSmallLetter" [controlName]="passwordCtrName"></app-form-requirement>
  <app-form-requirement labelKey="passwd.big" key="noBigLetter" [controlName]="passwordCtrName"> </app-form-requirement>
  <app-form-requirement labelKey="passwd.digit" key="noDigit" [controlName]="passwordCtrName"> </app-form-requirement>
  <app-form-requirement labelKey="passwd.special" key="noSpecialChar" [controlName]="passwordCtrName"></app-form-requirement>
  <app-form-requirement
    labelKey="passwd.length"
    [key]="['required', 'minlength']"
    [controlName]="passwordCtrName"
  ></app-form-requirement>
  <app-form-requirement
    labelKey="passwd.diff"
    key="passwordPrevious"
    *ngIf="reqNew"
    [controlName]="passwordCtrName"
  ></app-form-requirement>
  <app-form-requirement
    labelKey="passwd.confirm"
    [key]="['required', 'passwordEqual']"
    [controlName]="confirmCtrName"
  ></app-form-requirement>
</div>
